import awsmobile from '../config/aws-exports';
import apiRequest from '../utils/apiRequest';

export const putUserSubscriptionWeb = async (email, campaignId, optIn) =>
  await fetch(
    `${awsmobile.user_domain_url}/api/user/subscriptions/web?` +
      `email=${email}&` +
      `campaign_id=${campaignId}&` +
      `opt_in=${optIn}`,
    {
      body: JSON.stringify({
        email,
        campaign_id: campaignId,
        opt_in: optIn,
      }),
      method: 'put',
    },
  ).then(async res => ({
    ok: res.ok,
    status: res.status,
    json: await res.json(),
  }));

/**
 * Set store item by key
 * @param {string} key
 * @param {object} data
 * @return {Promise<any>}
 */
export const setStoreByKey = async (key, data) =>
  await apiRequest(
    `${awsmobile.user_domain_url}/api/store/${key}`,
    'PUT',
    data,
  );

/**
 * Get store item by key
 * @param {string} key
 * @return {Promise<any>}
 */
export const getStoreByKey = async key =>
  await apiRequest(`${awsmobile.user_domain_url}/api/store/${key}`);
